import React from 'react';
import Modal from 'react-modal'
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer'
import { useEffect, useLayoutEffect, useState } from 'react'
import './DocumentViewer.styles.scss'

export default function DocumentViewer(props) {

    const { isOpen, fileData, handleClose } = props
    const fileName = props.fileName;
    const [openModal, setOpenModal] = useState(isOpen)

    useEffect(() => { 
        setOpenModal(isOpen)
    }, [isOpen])

    return (
        <Modal 
            appElement={document.getElementById('root')}
            isOpen={openModal}
            contentLabel="documentViewerModalDialog"
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            className="documentViewerModalDialog"
        >
            <div className="row pull-right">
                <div className="col-lg-1">
                    <div 
                        className="closeButton"
                        onClick={handleClose}>
                        <i className="fa fa-2x fa-times"></i>
                    </div>
                </div>
            </div>
            <div className="row" style={{ height: "100%" }}>
                <div className="col-lg-12" style={{ height: "100%" }}>
                    <DocViewer
                        style={{ height: "100%" }}
                        pluginRenderers={DocViewerRenderers}
                        documents={[{
                            uri: fileData
                        }]}
                        config={{
                            header: {
                                disableFileName: true,
                                disableHeader: false,
                                overrideComponent: (state) => <MyHeader state={state} fileName={fileName} />
                            }
                        }}
                    />
                </div>
            </div>
        </Modal>
    )
}

function MyHeader ({state, fileName}) {
    const documentLoading = state.documentLoading
    useLayoutEffect(() => {
        const pdfDownload = document.getElementById("pdf-download")
            if(pdfDownload) {
                pdfDownload.download = fileName ?? "applicaiton.pdf";
            }
    }, [documentLoading, fileName])

    return (<></>)
}
